const toLocaleDateString = value => {
  const date = new Date(value).toLocaleDateString('pt-br')
  return value ? date : null
}

const summary = state =>
  state.summary
    ? {
        ...state.summary,
        comorbiditiesConditions: state.summary.comorbiditiesConditions.map(
          item => ({
            ...item,
            startedAt: toLocaleDateString(item.startedAt),
            addedAt: toLocaleDateString(item.addedAt)
          })
        )
      }
    : {
        id: null,
        personId: null,
        curiosity: null,
        comorbiditiesConditions: [],
        pregnancy: null,
        imc: null
      }

const clinicalBackgrounds = state =>
  state.clinicalBackgrounds ?? { medicines: [], allergies: [], habits: [] }

const triage = state =>
  state.triage ?? {
    navigationStatus: undefined,
    questions: undefined,
    appointments: undefined
  }

const timeline = state => state.timeline ?? []

const liteProfile = state => state.liteProfile

export default {
  triage,
  summary,
  timeline,
  clinicalBackgrounds,
  liteProfile
}
